<template>
	<div class="d-flex align-center">
		<v-menu
			v-model="showTasksMenu"
			:close-on-content-click="false"
			left
			:nudge-left="0"
		>
			<template v-slot:activator="{ on, attrs }">
				<v-icon color="blue darken-2" v-bind="attrs" v-on="on" size="28"
					>far fa-bell</v-icon
				>
				<span
					v-show="PendingRemindersCount > 0"
					v-bind="attrs"
					v-on="on"
					class="badgeCounter blue darken-2 white--text"
					>{{ PendingRemindersCount }}</span
				>
			</template>
			<v-card width="300">
				<v-card-text
					style="max-width: 300px; max-height: 80vh; overflow-y: auto;"
				>
					<v-skeleton-loader
						v-if="loadingReminders"
						type="list-item, list-item, list-item"
					></v-skeleton-loader>
					<div v-if="!loadingReminders">
						<div>
							<v-btn
								small
								block
								dark
								class="nyGreen darken-2 text-capitalize"
								@click="showAddTaskDialog = true"
								v-if="!showAddTaskDialog"
								>Aggiungi Promemoria</v-btn
							>
							<div
								class="pa-2 grey lighten-2 rounded"
								v-if="showAddTaskDialog"
							>
								<v-textarea
									rows="2"
									auto-grow
									dense
									v-model="newReminderDescription"
									label="Promemoria"
									prepend-icon="fas fa-sticky-note"
								></v-textarea>
								<DatePicker
									v-model="newReminderDate"
									label="Data"
								></DatePicker>

								<div class="d-flex">
									<v-spacer></v-spacer>
									<v-btn
										color="primary"
										small
										text
										@click="showAddTaskDialog = false"
										>{{ $t("common.cancel") }}</v-btn
									>

									<v-btn
										color="primary"
										small
										@click="AddReminder"
										>{{ $t("common.add") }}</v-btn
									>
								</div>
							</div>
						</div>
						<div
							class="text-center pa-2 grey lighten-2 rounded my-2 poppins-regular"
							v-if="RemindersView.length === 0"
						>
							Non ci sono promemoria per questo paziente.
						</div>
						<div
							v-for="r in RemindersView"
							:key="r.ReminderId"
							class="pa-2 poppins-regular"
						>
							<div class="mb-2 d-flex align-start">
								<v-icon
									v-if="r.Checked"
									color="grey lighten-1"
									class="mt-1"
									@click="
										UpdateCheckedStatus(r.ReminderId, false)
									"
									>far fa-check-square</v-icon
								>
								<v-icon
									v-else
									class="mt-1"
									@click="
										UpdateCheckedStatus(r.ReminderId, true)
									"
									>far fa-square</v-icon
								>
								<span
									class="ml-2 flex-grow-1"
									:class="
										r.Checked
											? 'grey--text text--lighten-1'
											: ''
									"
								>
									<InlineEdit
										:value="r.Description"
										@input="
											UpdateDescription(
												r.ReminderId,
												$event
											)
										"
									></InlineEdit>
								</span>
							</div>
							<div class="text-right grey--text text--darken-1">
								<v-icon
									x-small
									@click="DeleteReminder(r.ReminderId)"
									>fas fa-trash</v-icon
								>

								{{ moment(r.Date).format("DD/MM/YYYY") }}
							</div>
							<v-divider class="my-1"></v-divider>
						</div>
						<div
							v-if="
								CompletedRemindersCount > 0 && !showAllReminders
							"
						>
							<v-btn
								small
								block
								dark
								text
								color="info"
								class="text-capitalize"
								@click="showAllReminders = true"
								>Completati
								<span class="font-weight-bold">{{
									CompletedRemindersCount
								}}</span>
								<v-icon right>fas fa-chevron-down</v-icon>
							</v-btn>
						</div>
						<div
							v-if="
								CompletedRemindersCount > 0 && showAllReminders
							"
						>
							<v-btn
								small
								block
								dark
								text
								color="info"
								class="text-capitalize"
								@click="showAllReminders = false"
								>Nascodi completati
								<v-icon right>fas fa-chevron-up</v-icon>
							</v-btn>
						</div>
					</div>
				</v-card-text>
			</v-card>
		</v-menu>
		<!--		<div-->
		<!--			v-if="reminders.length > 0 && !showAllReminders"-->
		<!--			class="red white&#45;&#45;text rounded-circle d-flex justify-center align-center"-->
		<!--			style="width: 20px; height: 20px; font-size: 12px; margin-left: 6px;"-->
		<!--		>-->
		<!--			{{ 3 }}-->
		<!--		</div>-->
	</div>
</template>

<script>
import CrudClient from "@/services/CrudClient";
import DatePicker from "@/components/Shared/FormControl/DatePicker.vue";
import { mapActions } from "vuex";
import moment from "moment";
import InlineEdit from "@/components/Chat/InlineEdit.vue";

export default {
	name: "NutritionistRemindersActions",
	components: { InlineEdit, DatePicker },

	props: {
		UserId: {
			type: String,
			required: true
		}
	},
	data() {
		return {
			RemindersService: new CrudClient("CurrentNutritionist/Reminders"),
			loadingReminders: false,
			showTasksMenu: false,

			reminders: [],

			addingReminder: false,
			showAddTaskDialog: false,
			newReminderDescription: "",
			newReminderDate: "",
			showAllReminders: false,

			inlineEditTest: null
		};
	},
	computed: {
		RemindersView() {
			if (this.showAllReminders) {
				return this.reminders;
			} else {
				return this.reminders.filter(r => !r.Checked);
			}
		},
		CompletedRemindersCount() {
			return this.reminders.filter(r => r.Checked).length;
		},

		PendingRemindersCount() {
			return this.reminders.filter(r => !r.Checked).length;
		}
	},
	watch: {
		UserId: {
			immediate: true,
			handler: async function (val) {
				this.$log.debug(val);
				if (val) {
					await this.LoadReminders();
				}
			}
		},
		showTasksMenu: async function (val) {
			this.$log.debug(val);
			if (val) {
				await this.LoadReminders();
			}
		}
	},
	created() {
		this.moment = moment;
	},
	methods: {
		...mapActions(["snackSuccess", "snackError"]),

		async LoadReminders() {
			try {
				this.loadingReminders = true;
				const res = await this.RemindersService.GetPaged({
					skip: 0,
					limit: 0,
					filter: `PatientUserId:${this.UserId}`,
					fields: "*",
					orderBy: "Date"
				});
				this.reminders = res.Data;
			} catch (error) {
				this.$captureError(error);
				this.snackError({
					Text: this.$t("common.error.cannotLoadData")
				});
			} finally {
				this.loadingReminders = false;
			}
		},

		async AddReminder() {
			try {
				this.addingReminder = true;
				await this.RemindersService.Post(null, {
					PatientUserId: this.UserId,
					Description: this.newReminderDescription,
					Date: this.newReminderDate,
					Checked: false
				});

				await this.LoadReminders();

				// clear input fields
				this.newReminderDescription = "";
				this.newReminderDate = "";
				this.showAddTaskDialog = false;
			} catch (error) {
				this.$captureError(error);
				this.snackError({
					Text: this.$t("common.error.cannotSaveData")
				});
			} finally {
				this.addingReminder = false;
			}
		},

		async DeleteReminder(reminderId) {
			try {
				await this.RemindersService.Delete(reminderId);

				this.reminders = this.reminders.filter(
					reminder => reminder.ReminderId !== reminderId
				);
			} catch (error) {
				this.$captureError(error);
				this.snackError({
					Text: this.$t("common.error.cannotSaveData")
				});
			} finally {
			}
		},

		async UpdateCheckedStatus(reminderId, isChecked) {
			this.$log.debug("UpdateCheckedStatus", reminderId, isChecked);
			try {
				await this.RemindersService.Patch(
					reminderId,
					{
						Checked: isChecked
					},
					false
				);

				// Update the local state to reflect the change
				const reminder = this.reminders.find(
					r => r.ReminderId === reminderId
				);
				if (reminder) {
					reminder.Checked = isChecked;
				}
			} catch (error) {
				this.$captureError(error);
				this.snackError({
					Text: this.$t("common.error.cannotSaveData")
				});
			}
		},

		async UpdateDescription(reminderId, value) {
			this.$log.debug("UpdateCheckedStatus", value);
			try {
				await this.RemindersService.Patch(
					reminderId,
					{
						Description: value
					},
					false
				);

				// Update the local state to reflect the change
				const reminder = this.reminders.find(
					r => r.ReminderId === reminderId
				);
				if (reminder) {
					reminder.Description = value;
				}
			} catch (error) {
				this.$captureError(error);
				this.snackError({
					Text: this.$t("common.error.cannotSaveData")
				});
			}
		}
	}
};
</script>
<style scoped lang="scss">
.badgeCounter {
	padding-top: 1px;
	margin-bottom: 10px;
	margin-left: -6px;
	border-radius: 50%;
	height: 20px;
	width: 20px;
	text-align: center;
	font-size: 12px;
}
</style>
